import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {ServicePhoto} from '../../../core/entities/service/service-photo.entity';

@Injectable({
  providedIn: 'root'
})
export class ServicePhotoService
{
  public constructor(
    private readonly http: HttpClient,
  ) {}

  public list(serviceId: number): Observable<ServicePhoto[]> {
    return this.http.get<ServicePhoto[]>(`${environment.apiUrl}/manage/service/${serviceId}/photos`);
  }

  public addPhotos(serviceId: number, photos: File[]): Observable<ServicePhoto[]> {
    const formData = new FormData();
    photos.forEach((photo) => formData.append('photos[]', photo));

    return this.http.post<ServicePhoto[]>(`${environment.apiUrl}/manage/service/${serviceId}/photos`, formData);
  }

  public deletePhoto(serviceId: number, photoId: number): Observable<ServicePhoto> {
    return this.http.delete<ServicePhoto>(`${environment.apiUrl}/manage/service/${serviceId}/photos/${photoId}`);
  }

  public updateOrder(serviceId: number, orderedPhotos: { id: number; position: number }[]): Observable<{ success: boolean }> {
    return this.http.put<{ success: boolean }>(
      `${environment.apiUrl}/manage/service/${serviceId}/photos/order`,
      orderedPhotos
    );
  }
}
